import React from 'react'

type IconProps = {
  size?: number
  color?: string
  className?: string
}

const PlusIcon: React.FC<IconProps> = ({ size = '16', color = 'currentColor', ...attributes }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill={color} xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <g clipPath="url(#clip0_18_10)">
        <path d="M20 9.20025H10.806V0H9.20025V9.20025H0V10.806H9.20025V20H10.806V10.806H20V9.20025Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_18_10">
          <rect width={size} height={size} fill={color} />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PlusIcon
